import React from 'react';
import './SubGallery.scss';

const SubGallery = ({ section, onSectionUpdate }) => {
  return (
    <div className="sub-gallery-section">
      <h3>Sub-Gallery Section</h3>
      {/* Add sub-gallery implementation here */}
    </div>
  );
};

export default SubGallery;